import Raven from 'raven-js';

Raven.config(window.raven, { environment: window.ravenEnv }).install();
